import { fetchdata } from 'apis/FetchData';
import { handle420 } from 'apis/HandleError';
import { apiConfig } from 'config';

export const getFeatureToggle = () => {
  const url = apiConfig.swManagerGetFeatureToggle;
  return fetchdata(url, { method: 'GET' })
    .then((result) => result)
    .catch((e) => {
      switch (e.message) {
        case '420':
          handle420();
          break;
        default:
          throw e;
      }
    });
};
